export default "__VITE_ASSET__BWsaVPFy__"